import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UserDataService } from '../../../../shared/services/userData.service';
import { CustomEopService } from '../../../../shared/services/customEop.service';
import { SpinnerComponent } from '../../../components/spinner/spinner.component';
import { NoEmojiDirective } from '../../../../shared/helpers/noEmoji.directive';

@Component({
  selector: 'add-custom-page',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SpinnerComponent,
    NoEmojiDirective
  ],
  templateUrl: './add-custom-page.component.html',
  styleUrl: './add-custom-page.component.css'
})
export class AddCustomPageComponent implements OnInit {

  @Output() onClose = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<any>();

  currentBuildingId: string | null = null;

  loading: boolean = false;

  constructor(
    private userDataService: UserDataService,
    private customEopService: CustomEopService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
  }

  newCustomPageTitle: string = '';

  saveNewCustomPage() {
    if (!this.newCustomPageTitle) return;
    if (this.currentBuildingId) {
      this.loading = true;
      console.log('Submitted new custom page name:', this.newCustomPageTitle);
      this.customEopService.createBuildingCustomPage(this.currentBuildingId, this.newCustomPageTitle).subscribe({
        next: (response) => {
          console.log('New custom page created:', response);
          this.loading = false;
          this.onSave.emit({'type': 'success', 'message': 'This occurred after adding new custom page.'});
        },
        error: (error) => {
          this.loading = false;
          console.error('Error:', error.message);
          this.onSave.emit({type: 'unsuccess', 'message': error.message});
        }
      });
    }
  }

  handleClose() {
    this.onClose.emit();
  }

}
